import { createFileRoute, Outlet } from '@tanstack/react-router'

function AccountsLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/_authed/_user/accounts')({
  component: AccountsLayout,
  beforeLoad: () => ({
    getTitle: () => 'Accounts',
  }),
})
